import { render } from "./SearchBox.vue?vue&type=template&id=ce554918&scoped=true"
import script from "./SearchBox.vue?vue&type=script&lang=js"
export * from "./SearchBox.vue?vue&type=script&lang=js"

import "./SearchBox.vue?vue&type=style&index=0&id=ce554918&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce554918"]])

export default __exports__